export const obfuscateCardNumber = (cardNum: string): string => {
  const cardNumber = cardNum.replaceAll(' ', '');
  const visibleDigits = 4;
  const numVisibleDigits = cardNumber.length - visibleDigits;
  const obfuscatedDigits = 'X'.repeat(numVisibleDigits);
  return `${obfuscatedDigits}${cardNumber.slice(-visibleDigits)}`;
};
